import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.map";
import { isArray, isObject } from "./assertion";
import { objectKeys, merge } from "./object";
import { getLastItem } from "./array";
export function mapResponsive(prop, mapper) {
  if (isArray(prop)) {
    return prop.map(function (item) {
      if (item === null) {
        return null;
      }

      return mapper(item);
    });
  }

  if (isObject(prop)) {
    return objectKeys(prop).reduce(function (result, key) {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }

  if (prop != null) {
    return mapper(prop);
  }

  return null;
}
export function objectToArrayNotation(obj) {
  var base = [["base", null], ["sm", null], ["md", null], ["lg", null]];
  var entries = merge(base, Object.entries(obj));
  var mergedObj = Object.fromEntries(entries);
  var array = Object.values(mergedObj);
  var isNullBetweenValues = false;
  array.forEach(function (item, index) {
    var next = array[index + 1];

    if (item === null && next != null) {
      isNullBetweenValues = true;
    }
  });

  if (!isNullBetweenValues) {
    array = array.filter(function (item) {
      return item !== null;
    });
  }

  while (getLastItem(array) === null) {
    array.pop();
  }

  return array;
}